import clsx from "clsx";
import { ReactNode } from "react";
import { ButtonTypes } from "../../utils/consts";
const variants = {
  primary:
    "bg-secondary text-white hover:bg-[#a32c07] ",
  secondary: "text-burntBlack bg-secondary hover:bg-[#E9AD09]",
  light: "text-burntBlack bg-white text-secondary hover:text-textSecondary",
  gray: "text-burntBlack bg-[#E9E9E9] hover:bg-burntBlack hover:text-white",
  transparent: "text-tertiary border-tertiary hover:before:bg-redborder-red-500 relative h-[50px] overflow-hidden border-2 border-red-500 bg-transparent before:rounded-tr-2xl before:rounded-br-2xl before:absolute before:bottom-0 before:left-0 before:top-0 before:z-0 before:h-full before:w-0 before:bg-primary before:transition-all before:duration-700 hover:border-primary hover:text-white  hover:before:left-0 hover:before:w-[105%]",

};

const Button = ({
  children,
  className,
  variant,
  onClick,
  disabled,
  type,
}: {
  children: ReactNode;
  className?: string;
  variant: keyof typeof variants;
  onClick?: () => void;
  disabled?: boolean;
  type?: ButtonTypes;
}) => {
  return (
    <button
      type={type}
      className={clsx(
        "flex justify-center items-center h-16 font-medium text-xl rounded-[10px] transition-all duration-300 ease-in-out",
        variants[variant],
        className
      )}
      disabled={disabled}
      onClick={onClick}
    >
      <span className="relative z-50 flex items-center gap-2">{children}</span>
    </button>
  );
};

export default Button;
